// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   BASE MODAL STYLES
============================================ */
.statusChange_statusChangeModal__6pLLS {
  margin: 16px;
}

.statusChange_statusChangeModal__6pLLS .MuiDialog-paper {
  margin: 16px;
  width: 100%;
  max-width: 500px;
  border-radius: 12px;
}

/* ============================================
   HEADER
============================================ */
.statusChange_modalHeader__LX1WT {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #f3f4f6;
}

.statusChange_modalTitle__OYSW7 {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  line-height: 30px;
}

.statusChange_closeButton__sGo1U {
  color: #6b7280;
}
.statusChange_closeButton__sGo1U:hover {
  background: #f3f4f6;
}

/* ============================================
   CONTENT
============================================ */
.statusChange_modalContent__v-O9H {
  padding-top: 24px;
  padding-bottom: 24px;
}

/* RESOLVE NOTICE */
.statusChange_resolveNotice__KHRVH {
  background: #e7f7ec;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 18px;
  color: #1f5e36;
}

.statusChange_resolveNoticeText__f-D3X {
  font-size: 13px;
  line-height: 1.35;
}

.statusChange_resolveNoticeSub__kMJrh {
  margin-top: 6px;
  font-size: 13px;
}

.statusChange_resolvedStatusSpan__xYa5l {
  font-weight: 700;
}

.statusChange_approvedByInput__7E3yF .MuiInputBase-input.Mui-disabled {
  color: #6b7280;
  -webkit-text-fill-color: #6b7280;
}

.statusChange_requiredMark__in6\\+I {
  color: #ef4444;
  margin-left: 4px;
}

/* OTP INFO BANNER */
.statusChange_otpInfo__OJwoP {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  border-radius: 10px;
  background: #eef6ff;
  color: #1e3a8a;
  margin-bottom: 18px;
}

.statusChange_otpAvatar__D495c {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #f43f5e;
  color: #fff;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 14px;
  flex: 0 0 auto;
}

.statusChange_otpMessage__B\\+omR {
  font-size: 13px;
  line-height: 1.35;
}

/* FORM */
.statusChange_formField__9SRng {
  margin-bottom: 24px;
  margin-top: 15px;
}

.statusChange_fieldLabel__P4diM {
  color: #1e293b;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
}

/* Select + Textarea */
.statusChange_statusSelect__AK3Ik {
  border-radius: 8px;
}

.statusChange_remarkField__3T39i {
  border-radius: 8px;
}

/* ============================================
   ACTION BUTTONS
============================================ */
.statusChange_modalActions__N8jbp {
  padding: 24px;
  border-top: 1px solid #f3f4f6;
  gap: 16px;
}

.statusChange_cancelButton__qotXh {
  background: #f1f5f9;
  color: #374151;
  padding: 7px 24px;
  border-radius: 8px;
}
.statusChange_cancelButton__qotXh:hover {
  background: #e5e7eb;
}

.statusChange_saveButton__Ola-5 {
  background: #644ee5;
  color: white;
  padding: 7px 24px;
  border-radius: 8px;
}
.statusChange_saveButton__Ola-5:hover {
  background: #6d28d9;
}

/* ============================================
   OTP SECTION
============================================ */
.statusChange_otpHeaderRow__qXkmR {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.statusChange_sendOtpBtn__fB2VW {
  color: #644ee5;
  font-weight: 600;
  text-transform: none;
}

.statusChange_otpInputsRow__Lp\\+YD {
  display: flex;
  gap: 12px;
  margin: 12px 0 6px 0;
  width: fit-content;
}

.statusChange_otpInput__y0uUQ {
  width: 56px;
  height: 56px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  background: #f8fafc;
  color: #111827;
  flex: 0 0 auto;
}
.statusChange_otpInput__y0uUQ:focus {
  border-color: #644ee5;
  outline: none;
}

.statusChange_otpMetaRow__-\\+mA0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.statusChange_otpTimer__i0w-A {
  color: #ef4444;
  font-size: 12px;
}

.statusChange_resendBtn__BA8vM {
  color: #644ee5;
  font-weight: 600;
  text-transform: none;
}

/* ============================================
   RESPONSIVE BREAKPOINTS
============================================ */

/* ============ MOBILE (0–600px) ============ */
@media (max-width: 600px) {
  /* Modal */
  .statusChange_statusChangeModal__6pLLS .MuiDialog-paper {
    margin: 8px !important;
    max-width: calc(100vw - 16px) !important;
  }

  /* Header */
  .statusChange_modalTitle__OYSW7 {
    font-size: 18px;
  }

  /* Content spacing */
  .statusChange_modalContent__v-O9H {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  /* Action buttons */
  .statusChange_modalActions__N8jbp {
    padding: 12px 16px;
    flex-direction: column;
    gap: 12px;
  }

  .statusChange_cancelButton__qotXh,
  .statusChange_saveButton__Ola-5 {
    width: 100%;
    padding: 12px;
    font-size: 15px;
  }

  /* OTP boxes shrink */
  .statusChange_otpInputsRow__Lp\\+YD {
    gap: 8px;
  }

  .statusChange_otpInput__y0uUQ {
    width: 42px;
    height: 46px;
    font-size: 16px;
    border-radius: 10px;
  }

  .statusChange_otpMetaRow__-\\+mA0 {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}

/* ============ SMALL TABLETS (600–900px) ============ */
@media (min-width: 600px) and (max-width: 900px) {
  .statusChange_modalTitle__OYSW7 {
    font-size: 19px;
  }

  .statusChange_otpInput__y0uUQ {
    width: 48px;
    height: 50px;
  }
}

/* ============ TABLETS (900–1200px) ============ */
@media (min-width: 900px) and (max-width: 1200px) {
  .statusChange_modalContent__v-O9H {
    padding: 20px;
  }
}

@media (max-width: 325px) {
  .statusChange_otpInput__y0uUQ {
    width: 30px;
    height: 30px;
    font-size: 14px;
    border-radius: 6px;
  }
  .statusChange_modalContent__v-O9H {
    padding-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminDashboard/Hospital_Complaint/components/statusChange.module.css"],"names":[],"mappings":"AAAA;;8CAE8C;AAC9C;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;;8CAE8C;AAC9C;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;8CAE8C;;AAE9C,+CAA+C;AAC/C;EACE,UAAU;EACV;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA,WAAW;EACX;IACE,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA,mBAAmB;EACnB;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ============================================\n   BASE MODAL STYLES\n============================================ */\n.statusChangeModal {\n  margin: 16px;\n}\n\n.statusChangeModal :global(.MuiDialog-paper) {\n  margin: 16px;\n  width: 100%;\n  max-width: 500px;\n  border-radius: 12px;\n}\n\n/* ============================================\n   HEADER\n============================================ */\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.modalTitle {\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  line-height: 30px;\n}\n\n.closeButton {\n  color: #6b7280;\n}\n.closeButton:hover {\n  background: #f3f4f6;\n}\n\n/* ============================================\n   CONTENT\n============================================ */\n.modalContent {\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n\n/* RESOLVE NOTICE */\n.resolveNotice {\n  background: #e7f7ec;\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin-bottom: 18px;\n  color: #1f5e36;\n}\n\n.resolveNoticeText {\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.resolveNoticeSub {\n  margin-top: 6px;\n  font-size: 13px;\n}\n\n.resolvedStatusSpan {\n  font-weight: 700;\n}\n\n.approvedByInput :global(.MuiInputBase-input.Mui-disabled) {\n  color: #6b7280;\n  -webkit-text-fill-color: #6b7280;\n}\n\n.requiredMark {\n  color: #ef4444;\n  margin-left: 4px;\n}\n\n/* OTP INFO BANNER */\n.otpInfo {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #eef6ff;\n  color: #1e3a8a;\n  margin-bottom: 18px;\n}\n\n.otpAvatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #f43f5e;\n  color: #fff;\n  display: grid;\n  place-items: center;\n  font-weight: 700;\n  font-size: 14px;\n  flex: 0 0 auto;\n}\n\n.otpMessage {\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n/* FORM */\n.formField {\n  margin-bottom: 24px;\n  margin-top: 15px;\n}\n\n.fieldLabel {\n  color: #1e293b;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  display: block;\n}\n\n/* Select + Textarea */\n.statusSelect {\n  border-radius: 8px;\n}\n\n.remarkField {\n  border-radius: 8px;\n}\n\n/* ============================================\n   ACTION BUTTONS\n============================================ */\n.modalActions {\n  padding: 24px;\n  border-top: 1px solid #f3f4f6;\n  gap: 16px;\n}\n\n.cancelButton {\n  background: #f1f5f9;\n  color: #374151;\n  padding: 7px 24px;\n  border-radius: 8px;\n}\n.cancelButton:hover {\n  background: #e5e7eb;\n}\n\n.saveButton {\n  background: #644ee5;\n  color: white;\n  padding: 7px 24px;\n  border-radius: 8px;\n}\n.saveButton:hover {\n  background: #6d28d9;\n}\n\n/* ============================================\n   OTP SECTION\n============================================ */\n.otpHeaderRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sendOtpBtn {\n  color: #644ee5;\n  font-weight: 600;\n  text-transform: none;\n}\n\n.otpInputsRow {\n  display: flex;\n  gap: 12px;\n  margin: 12px 0 6px 0;\n  width: fit-content;\n}\n\n.otpInput {\n  width: 56px;\n  height: 56px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  background: #f8fafc;\n  color: #111827;\n  flex: 0 0 auto;\n}\n.otpInput:focus {\n  border-color: #644ee5;\n  outline: none;\n}\n\n.otpMetaRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.otpTimer {\n  color: #ef4444;\n  font-size: 12px;\n}\n\n.resendBtn {\n  color: #644ee5;\n  font-weight: 600;\n  text-transform: none;\n}\n\n/* ============================================\n   RESPONSIVE BREAKPOINTS\n============================================ */\n\n/* ============ MOBILE (0–600px) ============ */\n@media (max-width: 600px) {\n  /* Modal */\n  .statusChangeModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    max-width: calc(100vw - 16px) !important;\n  }\n\n  /* Header */\n  .modalTitle {\n    font-size: 18px;\n  }\n\n  /* Content spacing */\n  .modalContent {\n    padding-top: 16px;\n    padding-bottom: 16px;\n  }\n\n  /* Action buttons */\n  .modalActions {\n    padding: 12px 16px;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .cancelButton,\n  .saveButton {\n    width: 100%;\n    padding: 12px;\n    font-size: 15px;\n  }\n\n  /* OTP boxes shrink */\n  .otpInputsRow {\n    gap: 8px;\n  }\n\n  .otpInput {\n    width: 42px;\n    height: 46px;\n    font-size: 16px;\n    border-radius: 10px;\n  }\n\n  .otpMetaRow {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n}\n\n/* ============ SMALL TABLETS (600–900px) ============ */\n@media (min-width: 600px) and (max-width: 900px) {\n  .modalTitle {\n    font-size: 19px;\n  }\n\n  .otpInput {\n    width: 48px;\n    height: 50px;\n  }\n}\n\n/* ============ TABLETS (900–1200px) ============ */\n@media (min-width: 900px) and (max-width: 1200px) {\n  .modalContent {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 325px) {\n  .otpInput {\n    width: 30px;\n    height: 30px;\n    font-size: 14px;\n    border-radius: 6px;\n  }\n  .modalContent {\n    padding-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusChangeModal": `statusChange_statusChangeModal__6pLLS`,
	"modalHeader": `statusChange_modalHeader__LX1WT`,
	"modalTitle": `statusChange_modalTitle__OYSW7`,
	"closeButton": `statusChange_closeButton__sGo1U`,
	"modalContent": `statusChange_modalContent__v-O9H`,
	"resolveNotice": `statusChange_resolveNotice__KHRVH`,
	"resolveNoticeText": `statusChange_resolveNoticeText__f-D3X`,
	"resolveNoticeSub": `statusChange_resolveNoticeSub__kMJrh`,
	"resolvedStatusSpan": `statusChange_resolvedStatusSpan__xYa5l`,
	"approvedByInput": `statusChange_approvedByInput__7E3yF`,
	"requiredMark": `statusChange_requiredMark__in6+I`,
	"otpInfo": `statusChange_otpInfo__OJwoP`,
	"otpAvatar": `statusChange_otpAvatar__D495c`,
	"otpMessage": `statusChange_otpMessage__B+omR`,
	"formField": `statusChange_formField__9SRng`,
	"fieldLabel": `statusChange_fieldLabel__P4diM`,
	"statusSelect": `statusChange_statusSelect__AK3Ik`,
	"remarkField": `statusChange_remarkField__3T39i`,
	"modalActions": `statusChange_modalActions__N8jbp`,
	"cancelButton": `statusChange_cancelButton__qotXh`,
	"saveButton": `statusChange_saveButton__Ola-5`,
	"otpHeaderRow": `statusChange_otpHeaderRow__qXkmR`,
	"sendOtpBtn": `statusChange_sendOtpBtn__fB2VW`,
	"otpInputsRow": `statusChange_otpInputsRow__Lp+YD`,
	"otpInput": `statusChange_otpInput__y0uUQ`,
	"otpMetaRow": `statusChange_otpMetaRow__-+mA0`,
	"otpTimer": `statusChange_otpTimer__i0w-A`,
	"resendBtn": `statusChange_resendBtn__BA8vM`
};
export default ___CSS_LOADER_EXPORT___;
